import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveSessions, BarCodeCategory, InteractionType, KeyValues3, KeyValueSet, KeyValueSets, LastUsedKey, LastUsedSettingsType, LocalService, PageKey, SeatsInitialization, SessionConfigType, Status, TriggeredEvent, Wrappers10 } from '../../../service/local.service';
import { SeatReservationConfigComponent } from '../../popups/seat-reservation-config/seat-reservation-config.component';
import { SeatsQueueComponent } from '../../popups/seats-queue/seats-queue.component';
import { SessionConfigComponent } from '../../popups/session-config/session-config.component';
import { WsUserService } from 'src/service/ws/ws-user.service';
import { EmitType, RegisterName } from 'src/service/ws/wsSupporting/wsTypes';
import { EmitResponse } from 'src/service/ws/wsSupporting/wsEntities';
import { ProfileManagementService } from 'src/service/profile-management.service';
import { ReceiptTemplateSelectorComponent } from 'src/app/shared/receipt-template-selector/receipt-template-selector.component';

@Component({
  selector: 'app-seat-reservation',
  templateUrl: './seat-reservation.component.html',
  styleUrls: ['./seat-reservation.component.scss']
})
export class SeatReservationComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["reservation", "table"]; seats: SeatsInitialization; maxBodyHeight = 0;
  ctryCode: string = ''; userId: string = ''; businessId: string = ''; interactionType: InteractionType; isElligibleForBill = true;
  expandedKeys: string[] = []; isLiveMode = true; wrappers: Wrappers10; ignoreSessionIds: string[] = []; activeSessions: ActiveSessions;
  isEnabled = true; isTableMode = false;
  isOpenDeleteConfirmationBox = false; deleteConfirmationMessage: string = ''; tableIdToDetachBill: string = ''; billIdToDetach: string = ''; categoryCode: BarCodeCategory = BarCodeCategory.ExploreProducts;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal, private billingManagementService: BillingManagementService, private cdr: ChangeDetectorRef, private router: Router, private wsUserService: WsUserService, private profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onCheckWsBusinesEmitDetection();
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      this.isLiveMode = this.interactionType != InteractionType.User;
      this.isElligibleForBill = this.interactionType != InteractionType.ServiceProvider;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.SeatReservationBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.SeatReservationServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.SeatReservationUser);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onGetLastUsedSettings();
  }

  selectedTableId: string = '';
  onGenerateBarCode(key: string) {
    if (this.selectedTableId == key) {
      this.selectedTableId = '';
    } else {
      this.selectedTableId = key;
    }
  }

  onLoad() {
    if (this.isLiveMode) {
      this.billingManagementService.getSeatsInitialization(this.businessId).subscribe(result => {
        let seats = result;
        this.isEnabled = result.isEnabled;
        this.expandedKeys.forEach(item => {
          seats.groups.find(x => x.key == item).isSelected = true;
        });
        this.seats = seats;
      });
    } else {
      this.billingManagementService.getSessions(this.businessId, !this.wrappers ? null : this.wrappers.paging).subscribe(result => {
        this.wrappers = result;
        this.isEnabled = result.isEnabled;
        this.activeSessions = {
          bills: [] as KeyValueSets[],
          seats: [] as SeatsInitialization[],
          sessions: this.wrappers.items
        } as ActiveSessions;
      });
    }
  }

  onAction(index, key = '', key2 = '') {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(SeatReservationConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.result.then((result) => {
          this.onLoad();
        }, (error) => {
          this.onLoad();
        });
      } break;
      case 2: {
        let item = this.seats.groups.find(x => x.key == key);
        item.isSelected = !item.isSelected;
        if (item.isSelected) {
          this.expandedKeys.push(key);
        } else {
          this.expandedKeys = this.expandedKeys.filter(x => x != key);
        }
      } break;
      case 3: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.Add;
        modalRef.componentInstance.isElligibleForBill = this.isElligibleForBill;
        modalRef.result.then((result) => {
          this.onLoad();
        }, (error) => {
          this.onLoad();
        });
      } break;
      case 4: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.AttachBill;
        modalRef.componentInstance.isElligibleForBill = this.isElligibleForBill;
      } break;
      case 5: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.View;
        modalRef.componentInstance.isElligibleForBill = this.isElligibleForBill;
      } break;
      case 6: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.Delete;
        modalRef.componentInstance.isElligibleForBill = this.isElligibleForBill;
        modalRef.result.then((result) => {
          this.onLoad();
        }, (error) => {
          this.onLoad();
        });
      } break;
      case 7: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.seatId = key;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.SeatInfo;
        modalRef.componentInstance.isElligibleForBill = this.isElligibleForBill;
        modalRef.result.then((result) => {
          this.onLoad();
        }, (error) => {
          this.onLoad();
        });
      } break;
      case 8: {
        const modalRef = this.modalService.open(SeatsQueueComponent);
        modalRef.componentInstance.businessId = this.businessId;
      } break;
      case 9: {
        this.isLiveMode = !this.isLiveMode;
        this.onLoad();
      } break;
      case 10: {
        this.router.navigate(['/billing-tbl' + this.localService.basicParamsString, this.businessId, key2, key]);
      } break;
      case 11: {
        const customerTemplateIds = this.localService.getCustomerCopiesTemplateIds();
        if (this.interactionType != InteractionType.Bill_PnixSoft && customerTemplateIds.length == 1) {
          this.router.navigate(['/rv/' + this.ctryCode, customerTemplateIds[0], key]);
        } else {
          const modalRef = this.modalService.open(ReceiptTemplateSelectorComponent);
          modalRef.componentInstance.receiptId = key;
          modalRef.componentInstance.isLoadTemplate = this.interactionType == InteractionType.Bill_PnixSoft;
          modalRef.componentInstance.businessId = this.businessId;
        }
      } break;
      case 12: {
        this.tableIdToDetachBill = key;
        this.billIdToDetach = key2;
        const table = this.seats.groups.find(x => x.key == key);
        const valueToReplace = '<b>' + (table ? table.v1 : '') + '</b>';
        this.deleteConfirmationMessage = this.localService.replaceAll(this.localService.languageContent.reservation.detach_table_bill_conf, '##tbl_name##', valueToReplace);
        this.isOpenDeleteConfirmationBox = true;
      } break;
      case 13: {
        this.router.navigate(['/billing-tbl' + this.localService.basicParamsString, this.businessId, '0', key]);
      } break;
    }
  }

  onGetTableBills(tableId: string): string[] {
    const item = this.seats.tableBills.find(x => x.key == tableId);
    const items: string[] = item ? item.values : [];
    return items;
  }

  onGetSeatArrangement(key): KeyValueSet[] {
    return this.seats.availablity.find(x => x.key == key).value;
  }

  isSeatsLoaded(sessionKey): boolean {
    let item = this.activeSessions.seats.find(x => x.sessionKey == sessionKey);
    return item ? true : false;
  }

  isBillsLoaded(sessionKey): boolean {
    let item = this.activeSessions.bills.find(x => x.key == sessionKey);
    return item ? true : false;
  }

  onGetSeats(strSessionId): KeyValues3[] {
    if (this.activeSessions.seats) {
      let item = this.activeSessions.seats.find(x => x.sessionKey == strSessionId);
      return item ? item.groups : [];
    } else {
      return [];
    }
  }

  onGetBills(strSessionId): KeyValueSet[] {
    if (this.activeSessions.seats) {
      let item = this.activeSessions.bills.find(x => x.key == strSessionId);
      return item ? item.value : [];
    } else {
      return [];
    }
  }

  onGetSeatArrangementBySessionId(strSessionId, key): KeyValueSet[] {
    return this.activeSessions.seats.find(x => x.sessionKey == strSessionId).availablity.find(x => x.key == key).value;
  }

  onActionSession(index, key = '') {
    switch (index) {
      case 3: {
        this.billingManagementService.getSeatsBySessionId(key, true).subscribe(result => {
          let item = this.activeSessions.seats.find(x => x.sessionKey == key);
          if (item) {
            item.availablity = result.availablity;
            item.groups = result.groups
          } else {
            this.activeSessions.seats.push(result);
          }
        });
      } break;
      case 8: {
        this.billingManagementService.getBillsBySessionId(key).subscribe(result => {
          let item = this.activeSessions.bills.find(x => x.key == key);
          if (item) {
            item.value = result.value;
          } else {
            this.activeSessions.bills.push(result);
          }
        });
      } break;
      case 10: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, key]);
      } break;
    }
  }

  onDelete(result: any) {
    this.isOpenDeleteConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.billingManagementService.detachBill(this.billIdToDetach, [this.tableIdToDetachBill], true, this.businessId).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.onLoad();
        }
      });
    }
  }

  onCheckWsBusinesEmitDetection() {
    this.wsUserService.onEmitDetected(RegisterName.BusinessEmitDetected).subscribe((res: EmitResponse) => {
      if (res.result) {
        const tableId = res.result.tableId;
        const bilingId = res.result.billingId;
        const userId = res.result.userId;

        if (userId != this.userId) {
          switch (res.emitType) {
            case EmitType.AttachedTableBill: {
              this.onAttachedDetachedTableBill(tableId, bilingId, true);
            } break;
            case EmitType.DetachedTableBill: {
              this.onAttachedDetachedTableBill(tableId, bilingId, false);
            } break;
          }
        }
      }
    });
  }

  onAttachedDetachedTableBill(tableId: string, bilingId: string, isAttach: boolean) {
    var tableBills = this.seats.tableBills.find(x => x.key == tableId);
    if (tableBills) {
      if (isAttach) {
        tableBills.values.push(bilingId);
      } else {
        tableBills.values = tableBills.values.filter(x => x != bilingId);
      }
    }

    var table = this.seats.groups.find(x => x.key == tableId);
    if (table) {
      table.v3 = tableBills.values.length > 0 ? '1' : '0';
    }
  }

  onSaveLastUsedSettings() {
    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.SeatManagementTableMode, this.businessId);
    const status: string = this.isTableMode ? '1' : '0';
    if (temp != status)
      items.push({ keyType: LastUsedSettingsType.SeatManagementTableMode, value: status } as LastUsedKey);

    if (items.length > 0) {
      this.profileManagementService.saveLastUsedSettings(items, this.businessId).subscribe(result => {
      });
    }
  }

  onGetLastUsedSettings() {
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.SeatManagementTableMode, this.businessId);
    if (temp) {
      this.isTableMode = temp == '1';
    }
  }
}
